import type { UserRepository } from '../repository/UserRepository';
import type { CreateUserRequest, CreateUserResponse } from '../entity/UserTypes';

export class CreateUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(request: CreateUserRequest): Promise<CreateUserResponse> {
    if (!request.email?.trim()) {
      throw new Error('이메일은 필수입니다.');
    }
    return this.repository.createUser(request);
  }
}

